module.exports = __webpack_public_path__ + "media/crypto_powerlist/Triangle-a0b82974.png";